import _formatTags from "../../dict/formatTags.js";
const formatTags = _formatTags;
export default (function replaceUnderlineTags(text, openTag, closeTag) {
  let openPattern = new RegExp(formatTags.underline.open, "gmi"),
    closePattern = new RegExp(formatTags.underline.close, "gmi");
  return text.replace(openPattern, openTag).replace(closePattern, closeTag);
});